const defaultURL = "https://sgenaiapi.azurewebsites.net/";
const resume_analytics_upload = "/resume_analytics/upload";
const resume_analytics_ask = "/resume_analytics/ask";


export default {
  defaultURL,
  resume_analytics_upload,
  resume_analytics_ask,
};
